import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardApi } from '../../services/api';

export const fetchDashboard = createAsyncThunk(
  'dashboard/stats',
  async (periodId, { rejectWithValue }) => {
    try {
      const res = await dashboardApi.stats(periodId);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

const initialState = {
  data: null,
  status: 'idle',
  error: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboard.pending, (s) => { s.status = 'loading'; s.error = null; })
      .addCase(fetchDashboard.fulfilled, (s, a) => {
        s.status = 'succeeded';
        s.data = a.payload;
      })
      .addCase(fetchDashboard.rejected, (s, a) => { s.status = 'failed'; s.error = a.payload; });
  },
});

export default dashboardSlice.reducer;
